import { Component, OnInit, OnDestroy, HostListener, Input, inject } from '@angular/core';
import { NavComponent } from 'app/shared/components/nav/nav.component';
import { Office } from 'app/core/models/office.model';
import { UserPresenceService } from 'app/core/services/user-presence.service';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
const userPresenceKey = 'office';

@Component({
    selector: 'app-office-nav',
    templateUrl: './office-nav.component.html',
    styleUrls: ['./office-nav.component.scss'],
    imports: [UserPresenceComponent]
})
export class OfficeNavComponent extends NavComponent implements OnInit, OnDestroy {
  private userPresenceService = inject(UserPresenceService);

  @Input() office: Office;

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(): void {
    this.leaveAndUnsubscribe();
  }

  ngOnInit() {
    this.subscribeAndJoin();
  }

  ngOnDestroy(): void {
    this.leaveAndUnsubscribe();
  }

  private subscribeAndJoin() {
    this.userPresenceService.subscribeAndJoin(userPresenceKey, this.office.id);
  }

  private leaveAndUnsubscribe() {
    this.userPresenceService.leaveAndUnsubscribe(userPresenceKey, this.office.id);
  }
}
